import {
  Flex, FormControl, FormLabel, Icon, Tooltip,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { Select, chakraComponents } from 'chakra-react-select';
import { BsExclamationTriangle } from 'react-icons/bs';
import React from 'react';

const MultiValueLabel = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  if (props.data.validated) return <chakraComponents.MultiValueLabel {...props} />;
  return (
    <Tooltip label="Email validation pending">
      <Flex align="center">
        <Icon as={BsExclamationTriangle} mr="1" color="orange.600" />
        <chakraComponents.MultiValueLabel {...props} />
      </Flex>
    </Tooltip>
  );
};
const components = {
  DropdownIndicator: null,
  MultiValueLabel,
};

const WhenField = ({ control }) => {
  const options = [{ value: 'onsubmit', label: 'On Submit' },
    { value: 'daily', label: 'Daily resume', isDisabled: true },
  ];

  return (
    <FormControl my="4">
      <FormLabel fontSize="sm">When:</FormLabel>
      <Controller
        control={control}
        name="when"
        render={({ field: { onChange, ref } }) => (
          <Select
            defaultValue={options.find((o) => o.value === 'onsubmit')}
            inputRef={ref}
            onChange={(val) => onChange(val.value)}
            components={components}
            placeholder="Select option"
            options={options}
          />
        )}
      />
    </FormControl>
  );
};

export default WhenField;
